export function minLenght(value: string) {
  return value.length >= 8;
}

export function hasAtLeastLetter(value: string) {
  return /[a-zA-Z]/.test(value);
}

export function hasAtLeastNumber(value: string) {
  return /\d/.test(value);
}
